<template>
  <div class="meter-community-rate-chart">
    <Echart ref="option" :options="option" style="height: 100%" />
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'MeterCommunityRateChart',
  data() {
    return {
      option: {},
      url: {
        list: "/jeecg-engineering/ticket/tickets/list"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getData()
    },
    
    getData() {
      getAction(this.url.list).then(res => {
        if (res.success) {
          // Handle old screen API response format
          const data = []
          if (res.result && res.result.xdata && res.result.ydata) {
            for (let i = 0; i < res.result.xdata.length; i++) {
              data.push({
                name: res.result.xdata[i],
                num: res.result.ydata[i]?.num || 0,
                cnum: res.result.ydata[i]?.cnum || 0
              })
            }
            this.setOption(data)
          } else {
            this.setOption(this.getMockData())
          }
        } else {
          this.setOption(this.getMockData())
        }
      }).catch(() => {
        this.setOption(this.getMockData())
      })
    },
    
    getMockData() {
      return [
        { name: '阳光花园', num: 350, cnum: 320 },
        { name: '凯旋城', num: 400, cnum: 400 },
        { name: '碧水云天', num: 100, cnum: 80 },
        { name: '翡翠湾', num: 450, cnum: 402 },
        { name: '星河湾', num: 700, cnum: 700 },
        { name: '紫荆花园', num: 800, cnum: 777 },
        { name: '幸福家园', num: 350, cnum: 320 },
        { name: '金色华府', num: 350, cnum: 320 }
      ]
    },
    
    setOption(data) {
      const xData = []
      const totalData = []
      const readData = []
      const rateData = []
      
      data.forEach(item => {
        xData.push(item.name)
        totalData.push(item.num)
        readData.push(item.cnum)
        const rate = item.num > 0 ? Math.round((item.cnum / item.num) * 100) : 0
        rateData.push(rate)
      })
      
      this.option = {
        textStyle: {
          color: '#fff'
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(4, 22, 44, 0.8)',
          borderColor: 'rgba(0, 168, 255, 0.5)',
          borderWidth: 1,
          borderRadius: 4,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: (params) => {
            const name = params[0].axisValue
            const total = params[0].value
            const read = params[1].value
            const rate = params[2].value
            return `${name}<br/>${this.$t('总户数')}: ${total}<br/>${this.$t('抄见户数')}: ${read}<br/>${this.$t('抄见率')}: ${rate}%`
          }
        },
        legend: {
          show: true,
          itemHeight: 10,
          right: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          data: [this.$t('总户数'), this.$t('抄见户数'), this.$t('抄见率')]
        },
        color: ['#0394FF', '#50E3C2', '#F6BB2F'],
        xAxis: [{
          type: 'category',
          data: xData,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            rotate: 45
          },
          axisPointer: {
            type: 'shadow'
          }
        }],
        yAxis: [
          {
            type: 'value',
            name: this.$t('户数'),
            axisLabel: {
              color: '#fff',
              fontSize: 12
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['rgba(0, 168, 255, 0.2)']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('抄见率(%)'),
            nameTextStyle: {
              color: '#fff',
              align: 'center'
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: ['rgba(0, 168, 255, 0.2)']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value}%',
              color: '#fff',
              fontSize: 12
            }
          }
        ],
        series: [
          {
            name: this.$t('总户数'),
            type: 'bar',
            barWidth: 12,
            data: totalData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#0394FF' },
                  { offset: 0.5, color: 'rgba(3, 148, 255, 0.5)' },
                  { offset: 1, color: 'rgba(3, 148, 255, 0.1)' }
                ]
              }
            }
          },
          {
            name: this.$t('抄见户数'),
            type: 'bar',
            barWidth: 12,
            data: readData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: '#50E3C2' },
                  { offset: 0.5, color: 'rgba(80, 227, 194, 0.5)' },
                  { offset: 1, color: 'rgba(80, 227, 194, 0.1)' }
                ]
              }
            }
          },
          {
            name: this.$t('抄见率'),
            type: 'line',
            yAxisIndex: 1,
            data: rateData,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#F6BB2F'
            },
            lineStyle: {
              color: '#F6BB2F',
              width: 2
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.meter-community-rate-chart {
  height: 100%;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1200px) {
  .meter-community-rate-chart {
    padding: 0;
  }
}
</style>